import { queryStringToParameters, urlData } from './urlUtils';
import { getMGMToETL } from './mgmUtils';
import { getActiveExperiments } from './googleOptimize/storage';

const INITIAL_QUERY_STRING_KEY = 'initialQueryString';

function getQueryStringFromLocalStorage() {
  let initialQueryString = sessionStorage.getItem(INITIAL_QUERY_STRING_KEY);
  if (!initialQueryString) {
    initialQueryString = JSON.stringify(window.location);
    sessionStorage.setItem(INITIAL_QUERY_STRING_KEY, initialQueryString);
  }

  const initialQuery = JSON.parse(initialQueryString);

  return {
    ...initialQuery,
    search: initialQuery.search || '',
  };
}

export function getMarketingParameters() {
  const { location } = document;
  const queryString = getQueryStringFromLocalStorage();
  const marketingParameters = queryStringToParameters(queryString.search);

  return {
    ...marketingParameters,
    landing_url: queryString.href || location.href,
  };
}

export function getMarketingData({ additionalParameters = {} } = {}) {
  const { referrer } = document;
  const referrerHost = urlData(referrer).host;
  const marketingParameters = getMarketingParameters();
  const activeExperiments = getActiveExperiments();

  const parameters = {
    ...marketingParameters,
    ...getMGMToETL({
      hasReferralIdOnURL: marketingParameters.id,
    }),
    current_url: window.location.href,
    version: '5.0.0',
    project: 'www',
    experiments: activeExperiments,
    ...additionalParameters,
  };

  const differentHost = referrerHost !== document.location.host;
  const result = {};

  if (differentHost) {
    result.referrer = referrerHost;
  }

  if (parameters.utm_source) {
    result.network = parameters.utm_source;
  }

  result.parameters = JSON.stringify(parameters);

  return result;
}

export function persistMarketingURL(documentLocation = {}) {
  sessionStorage.setItem(
    INITIAL_QUERY_STRING_KEY,
    JSON.stringify(documentLocation),
  );
}
